/* TODO: t() */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text, XButton } from '../uiold';
import { themeColors } from '../uiold/Constants';

import { Group } from '../../types/shared/Group';

type Props = {
  group: Group;
  items: Array<React.ReactNode>;
  onSelect: (group: Group) => void;
  onRemove: (group: Group) => void;
  isSelect?: boolean;
};

function FieldGroup(props: Props) {
  let { group, items, onSelect, onRemove, isSelect } = props;
  return (
    <View style={[styles.groupWrapper, isSelect && { zIndex: 103 }]}>
      <View style={styles.groupHeader}>
        <View style={styles.groupTitle} onClick={() => onSelect(group)}>
          <Text>{group.title}</Text>
        </View>
        <XButton onPress={() => onRemove(group)} style={styles.remove} />
      </View>
      {items}
    </View>
  );
}

let styles = StyleSheet.create({
  groupWrapper: {
    backgroundColor: themeColors.white,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: '#eee',
    borderRadius: 5,
    margin: 5,
    zIndex: 100,
  },
  groupHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 5,
    paddingLeft: 20,
    backgroundColor: themeColors.lightGrey,
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
  },
  groupTitle: {
    justifyContent: 'center',
  },
  remove: {
    marginRight: 10,
  },
});

export default FieldGroup;
